// extracted by mini-css-extract-plugin
export default {"container":"gq-z","heading":"hq-z","text":"iq-z","info":"jq-z","link":"kq-z","fullMaxWidth":"lq-z"};